module.exports = __webpack_public_path__ + "img/home-decor-3.2d98a7aa.jpg";